import React, { useState, useEffect, useRef } from "react";
import AdminEventStatsS from "../ClubOwnerStyles/ClubOwnerEventStatsStyle.module.css";
import { FaArrowLeft } from "react-icons/fa";
import ChartComponent from "../../components/ChartComponent";
import TrimmableTextComponent from "../../components/EventsComp/TrimmableTextComponent";
import NumberSetup from "../../components/TablesComp/NumberSetup";
import EditEventForm from "../../components/EventsComp/EditInfo";
import axios from "axios";
import Frame from "../../icons/Frame.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import ClipLoader from "react-spinners/ClipLoader";
import EventCards from "../../components/EventsComp/EventCards";
import RenderClients from "../../components/EventsStats/RenderClients";
import TicketSalesTable from "../../components/EventsStats/TicketSalesTable";
import EventHeaderBar from "../../components/EventsStats/EventHeaderBar";
import { useParams, useNavigate } from "react-router-dom";

// A separate EventStatistics component as per original code
const EventStatistics = ({
  eventId,
  events,
  setSelectedEvent,
  activeSubTab,
  setActiveSubTab,
  isLiveEvent,
  stats,
  promoters,
  handlePromoterClick,
  selectedPromoter,
  tickets,
  setEvents,
  handleBackClick,
  adminId,
  clubId,
  role,
  adminKey,
  BACKEND_URL,
  viewMode,
  fetchStatsForEvent
}) => {
  const SubTabs = () => {
    const subTabs = isLiveEvent
      ? [
          "eventStats",
          "participants",
          "TeamManagement",
          "editInfo",
          "tablebooking"
        ]
      : ["eventStats", "participants", "TeamManagement"];

    const handleSubTabClick = (subTab) => {
      setActiveSubTab(subTab);
    };

    return (
      <div className={AdminEventStatsS.subtabsButton}>
        {subTabs.map((subTab) => (
          <button
            key={subTab}
            className={`${AdminEventStatsS.subtabsButton} ${
              activeSubTab === subTab ? AdminEventStatsS.active : ""
            }`}
            onClick={() => handleSubTabClick(subTab)}
          >
            {subTab === "eventStats" && "Event Stats"}
            {subTab === "participants" && "Participants"}
            {subTab === "TeamManagement" && "Team Management"}
            {subTab === "editInfo" && "Edit Info"}
            {subTab === "tablebooking" && "Table Booking"}
          </button>
        ))}
      </div>
    );
  };

  const BlocksComp = ({ title, value }) => {
    if (value === undefined) {
      return (
        <div className={AdminEventStatsS.metricBlock}>
          <span>Loading...</span>
        </div>
      );
    }

    return (
      <div className={AdminEventStatsS.metricBlock}>
        <span
          className={AdminEventStatsS.numbers}
          style={{
            color: title === "Revenue" ? "#1C3996" : "black"
          }}
        >
          {value}
        </span>
        <span className={AdminEventStatsS.textNumber}>{title}</span>
      </div>
    );
  };

  const PromoterComponent = ({ id, firstName, lastName, image, onClick }) => {
    return (
      <div
        onClick={() => onClick(id, `${firstName} ${lastName}`)}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          marginBottom: "10px"
        }}
      >
        <img
          src={image}
          alt={`${firstName} ${lastName}`}
          style={{
            borderRadius: "50%",
            marginRight: "10px",
            width: "40px",
            height: "40px",
            objectFit: "cover"
          }}
        />
        <span>{`${firstName} ${lastName}`}</span>
      </div>
    );
  };

  const AggregateAndRenderPromoters = ({ ClientData }) => {
    const aggregatedData = ClientData.reduce((acc, curr) => {
      const promoter = curr.referredBy || "Unknown";
      if (!acc[promoter]) {
        acc[promoter] = {
          total: 0,
          scanned: 0,
          ticketTypes: {},
          benefits: 0
        };
      }
      acc[promoter].total += 1;
      if (curr.hasScanned) acc[promoter].scanned += 1;
      acc[promoter].ticketTypes[curr.ticketType] =
        (acc[promoter].ticketTypes[curr.ticketType] || 0) + 1;
      acc[promoter].benefits += curr.price;
      return acc;
    }, {});

    const ticketTypes = [...new Set(ClientData.map((user) => user.ticketType))];

    const sortedAndRankedData = Object.entries(aggregatedData)
      .map(([promoter, data]) => ({
        promoter,
        ...data
      }))
      .sort((a, b) => {
        if (a.total !== b.total) return b.total - a.total;
        return b.scanned - a.scanned;
      })
      .map((data, index) => ({ ...data, rank: index + 1 }));

    const rankColors = {
      1: "#FFD700",
      2: "#C0C0C0",
      3: "#CD7F32"
    };

    return (
      <div>
        <table className={AdminEventStatsS.TicketStats}>
          <thead>
            <tr>
              <th>Rank</th>
              <th>Promoter</th>
              <th>Total Referrals</th>
              <th>Scanned Entries</th>
              {ticketTypes.map((type) => (
                <th key={type}>{type}</th>
              ))}
              <th>Total Benefits</th>
            </tr>
          </thead>
          <tbody>
            {sortedAndRankedData.map((data, index) => (
              <tr key={index}>
                <td>
                  <div
                    className={AdminEventStatsS.rankcircle}
                    style={{
                      backgroundColor: rankColors[data.rank] || "white"
                    }}
                  >
                    {data.rank}
                  </div>
                </td>
                <td>{data.promoter}</td>
                <td>{data.total}</td>
                <td>{data.scanned}</td>
                {ticketTypes.map((type) => (
                  <td key={type}>{data.ticketTypes[type] || 0}</td>
                ))}
                <td>€{data.benefits.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const requiresIframe =
    stats.tableData?.["QR_tech"]?.includes("SMD") ||
    stats.tableData?.["QR_tech"]?.includes("FOURVENUES");

  const blueColorVariants = [
    "#6baed6",
    "#4292c6",
    "#2171b5",
    "#08519c",
    "#08306b"
  ];

  return (
    <>
      {viewMode === "bar" && (
        <select
          onChange={(e) => {
            setSelectedEvent(e.target.value);
            fetchStatsForEvent(e.target.value);
          }}
          value={eventId || events[0]?._id || ""}
        >
          {events.map((event) => (
            <option key={event._id} value={event._id}>
              {event.eventName} -{" "}
              {new Date(event.dateAndHour).toLocaleDateString()}
            </option>
          ))}
        </select>
      )}
      <div className={AdminEventStatsS.tabsEvents}>
        {viewMode === "cards" && (
          <div className={AdminEventStatsS.tabsEvents}>
            <button
              onClick={handleBackClick}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "10px",
                paddingRight: "10px",
                paddingTop: "10px",
                paddingBottom: "10px",
                borderRadius: "10px",
                backgroundColor: "#F0F0F0",
                color: "#353943"
              }}
            >
              <FaArrowLeft style={{ marginRight: "8px" }} />
            </button>
          </div>
        )}
      </div>
      {eventId && events.length > 0 && (
        <EventHeaderBar
          image={events.find((e) => e._id === eventId)?.image || ""}
          eventName={events.find((e) => e._id === eventId)?.eventName || ""}
          dateAndHour={events.find((e) => e._id === eventId)?.dateAndHour || ""}
        />
      )}
      <SubTabs />
      {isLiveEvent && (
        <>
          <p style={{ marginBottom: "5px" }}>Event Link:</p>
          <TrimmableTextComponent selectedEventLive={eventId} />
        </>
      )}
      {requiresIframe ? (
        stats.tableData?.["QR_tech"]?.includes("SMD") ? (
          <iframe
            src="https://app.mgta.io/auth/login"
            title="SMD iframe"
            width="100%"
            height="600px"
          ></iframe>
        ) : (
          <iframe
            src="https://pro.fourvenues.com/"
            title="Fourvenues iframe"
            width="100%"
            height="600px"
          ></iframe>
        )
      ) : activeSubTab === "eventStats" ? (
        <>
          {selectedPromoter && (
            <>
              <div
                style={{
                  color: "#353943",
                  fontWeight: "bold",
                  marginTop: "20px"
                }}
              >
                Promoter Stats
              </div>
              <div
                className={AdminEventStatsS.promoterselection}
                onClick={() => handlePromoterClick(null)}
              >
                {selectedPromoter.name} X
              </div>
            </>
          )}
          <div className={AdminEventStatsS.metricsEvents}>
            <div className={AdminEventStatsS["metric revenue"]}>
              <BlocksComp title="Revenue" value={`€${stats.revenue}`} />
            </div>
            <BlocksComp
              title="Participants"
              value={`${stats.numberOfParticipants}`}
            />
            <BlocksComp
              title="Scanned Participants"
              value={`${stats.numberOfScannedUsers}`}
            />
          </div>
          <div className={AdminEventStatsS.TicketSPr}>
            <div className={AdminEventStatsS.TicketStats}>
              <TicketSalesTable tableData={stats.tableData} />
            </div>
            <div className={AdminEventStatsS.promoters}>
              <h2>Collaborators & Team Leaders</h2>
              <div>
                {promoters.map((promoter) => (
                  <PromoterComponent
                    key={promoter.id}
                    id={promoter.id}
                    image={promoter.image}
                    firstName={promoter.name}
                    lastName={promoter.email}
                    onClick={handlePromoterClick}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className={AdminEventStatsS.charts}>
            <div className={AdminEventStatsS.genderDistribution}>
              <ChartComponent
                title="Gender Distribution"
                data={stats.genderDistribution}
                chartType="Pie"
                nameKey="gender"
                blueColorVariants={blueColorVariants}
              />
            </div>
            <div className={AdminEventStatsS.ticketTypeDistribution}>
              <ChartComponent
                title="Ticket Type Distribution"
                data={stats.ticketTypeDistribution}
                chartType="Bar"
                nameKey="name"
              />
            </div>
            <div className={AdminEventStatsS.ageDistribution}>
              {stats.ageDistribution && (
                <ChartComponent
                  title="Age Distribution"
                  data={stats.ageDistribution}
                  chartType="Bar"
                  nameKey="age"
                />
              )}
            </div>
          </div>
        </>
      ) : activeSubTab === "participants" ? (
        <RenderClients ClientData={stats.userClientsData || []} />
      ) : activeSubTab === "TeamManagement" ? (
        <AggregateAndRenderPromoters ClientData={stats.userClientsData || []} />
      ) : activeSubTab === "editInfo" && isLiveEvent ? (
        <EditEventForm
          selectedEventId={eventId}
          events={events}
          ticketsdata={tickets}
          adminId={clubId}
          setEvents={setEvents}
        />
      ) : activeSubTab === "tablebooking" ? (
        <NumberSetup
          eventId={eventId}
          activeSubTab={activeSubTab}
          id={clubId}
          clubs={events.find((e) => e._id === eventId)?.club.id}
        />
      ) : null}
    </>
  );
};

const ClubOwnerEventStats = () => {
  const [clubId] = useState(localStorage.getItem("adminId"));
  const [role] = useState(localStorage.getItem("userRole"));
  const [clubs] = useState(localStorage.getItem("clubIds"));
  const [promoters, setPromoters] = useState([]);
  const [events, setEvents] = useState([]);
  const [allLiveEvents, setAllLiveEvents] = useState([]);
  const [allPastEvents, setAllPastEvents] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [stats, setStats] = useState({});
  const [tickets, setTickets] = useState([]);
  const [selectedPromoter, setSelectedPromoter] = useState(null);
  const [activeTab, setActiveTab] = useState("liveEvents");
  const [activeSubTab, setActiveSubTab] = useState("eventStats");
  const [showEventStats, setShowEventStats] = useState(false);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [loadingPromoters, setLoadingPromoters] = useState(false);
  const [loadingStats, setLoadingStats] = useState(false);
  const [clubsData, setClubsData] = useState([]);

  const { viewMode: urlViewMode, eventId: urlEventId } = useParams();
  const navigate = useNavigate();

  const [viewMode, setViewMode] = useState(
    urlViewMode === "bar" ? "bar" : "cards"
  );
  const [selectedEventId, setSelectedEventId] = useState(urlEventId || null);

  const adminKey = "Bearer " + process.env.REACT_APP_ADMIN_KEY;
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const isLoading = loadingEvents || loadingPromoters || loadingStats;

  const prevViewModeRef = useRef(viewMode);

  useEffect(() => {
    // When viewMode or selectedEventId changes, update the URL
    if (selectedEventId) {
      navigate(`/events-details/${viewMode}/${selectedEventId}`, {
        replace: true
      });
    } else {
      navigate(`/events-details/${viewMode}`, { replace: true });
    }
  }, [viewMode, selectedEventId, navigate]);

  useEffect(() => {
    const prevViewMode = prevViewModeRef.current;
    // If switching to bar view and no event selected, pick the first event automatically
    if (viewMode === "bar" && events.length > 0 && !selectedEventId) {
      const defaultEventId = events[0]._id;
      setSelectedEventId(defaultEventId);
      setShowEventStats(true);
    }

    prevViewModeRef.current = viewMode;
  }, [viewMode, events, selectedEventId]);

  useEffect(() => {
    const fetchClubs = async () => {
      try {
        let token = localStorage.getItem("token");
        const response = await axios.post(
          `${BACKEND_URL}/admin/searchClubs`,
          { clubIds: JSON.parse(clubs) },
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );
        if (response.status === 200) {
          setClubsData(response.data);
        } else {
          console.error(
            "Failed to fetch clubs:",
            response.status,
            response.statusText
          );
        }
      } catch (e) {
        console.error("Error fetching clubs:", e);
      }
    };

    const fetchAdminEvents = async () => {
      setLoadingEvents(true);
      try {
        let token = localStorage.getItem("token");
        const response = await axios.get(
          `${BACKEND_URL}/admin/getEventsClub/${clubId}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );
        if (response.status === 200) {
          const pastEvents = response.data.events.filter(
            (event) => event.isPastEvent
          );
          const currentAndFutureEvents = response.data.events.filter(
            (event) => !event.isPastEvent
          );
          setAllPastEvents(pastEvents);
          setAllLiveEvents(currentAndFutureEvents);
        } else {
          console.error("Failed to fetch events");
        }
      } catch (error) {
        console.error("Error fetching admin events:", error);
      }
      setLoadingEvents(false);
    };

    const fetchPromoters = async () => {
      setLoadingPromoters(true);
      try {
        let token = localStorage.getItem("token");
        const response = await axios.get(
          `${BACKEND_URL}/admin/team/${clubId}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );
        if (response.status === 200) {
          setPromoters(response.data.promotersData);
        }
      } catch (error) {
        console.error("Error fetching promoters:", error);
      }
      setLoadingPromoters(false);
    };

    fetchClubs();
    fetchAdminEvents();
    fetchPromoters();
  }, [clubId, adminKey, BACKEND_URL, clubs]);

  useEffect(() => {
    if (activeTab === "liveEvents") {
      setEvents(allLiveEvents);
    } else if (activeTab === "pastEvents") {
      setEvents(allPastEvents);
    }

    // Remove the resetting lines here. Just let events update.
    // Do not reset selectedEventId or showEventStats here.
  }, [activeTab, allLiveEvents, allPastEvents]);

  useEffect(() => {
    if (events.length > 0) {
      if (selectedEventId) {
        const eventExists = events.some((e) => e._id === selectedEventId);
        if (eventExists) {
          // Valid eventId from URL
          setShowEventStats(true);
          fetchStatsForEvent(selectedEventId);
        } else {
          // Invalid eventId
          if (viewMode === "bar") {
            const defaultEventId = events[0]._id;
            setSelectedEventId(defaultEventId);
            setShowEventStats(true);
          } else {
            // card mode with invalid event
            setSelectedEventId(null);
            setShowEventStats(false);
          }
        }
      } else {
        // No eventId in URL
        if (viewMode === "bar") {
          // Pick earliest event
          const defaultEventId = events[0]._id;
          setSelectedEventId(defaultEventId);
          setShowEventStats(true);
        } else {
          // Card mode no event chosen
          setShowEventStats(false);
        }
      }
    } else {
      // No events
      setSelectedEventId(null);
      setShowEventStats(false);
    }
  }, [events, selectedEventId, viewMode]);

  const fetchStatsForEvent = async (eventId, promoterId = null) => {
    setLoadingStats(true);
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${BACKEND_URL}/admin/event-stats/${eventId}`,
        { Id: clubId, role: role, promoterIds: promoterId },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );

      if (response.status === 200) {
        const data = response.data;
        if (activeTab === "liveEvents") {
          setTickets(data.tickets);
        }
        let calculatedRevenue = 0;
        const ticketsData = {
          "Ticket Type": [],
          "Price (€)": [],
          Sold: [],
          "Benefits (€)": [],
          QR_tech: [],
          "Ticket ID": []
        };
        data.tickets.forEach((ticket) => {
          const numTicketsSold = ticket.users_having_ticket?.length || 0;
          const ticketPrice = ticket.price;
          const benefits = numTicketsSold * ticketPrice;
          calculatedRevenue += benefits;
          ticketsData["Ticket ID"].push(ticket._id);
          ticketsData["Event ID"] = ticket.event.id;
          ticketsData["Ticket Type"].push(ticket.ticketType);
          ticketsData["Price (€)"].push(ticketPrice);
          ticketsData["Sold"].push(numTicketsSold);
          ticketsData["Benefits (€)"].push(benefits);
          ticketsData["QR_tech"].push(ticket.QR_tech);
        });
        const ticketTypesData = Object.entries(data.ticketTypeFrequencies).map(
          ([key, value]) => ({
            name: key,
            count: value
          })
        );
        const AgeFrequencyData = Object.entries(data.ageFrequencies).map(
          ([key, value]) => ({
            age: key,
            count: value
          })
        );
        const BachelorDistributionData = Object.entries(
          data.bachelorFrequencies
        ).map(([key, value]) => ({
          field: key,
          count: value
        }));
        const genderData = Object.entries(data.genderFrequencies).map(
          ([key, value]) => ({
            gender: key,
            count: value
          })
        );
        setStats({
          revenue: calculatedRevenue,
          numberOfParticipants: data.numberOfParticipants,
          numberOfScannedUsers: data.numberOfScannedUsers,
          tableData: ticketsData,
          genderDistribution: genderData,
          ticketTypeDistribution: ticketTypesData,
          ageDistribution: AgeFrequencyData,
          bachelorDistribution: BachelorDistributionData,
          userClientsData: data.users_data
        });
      } else {
        console.error("Failed to fetch stats");
      }
    } catch (error) {
      console.error("Error fetching event stats:", error);
    } finally {
      setLoadingStats(false);
    }
  };

  useEffect(() => {
    if (selectedItems.length > 0) {
      const filteredEventsLive = allLiveEvents.filter((event) =>
        selectedItems.includes(event.club.id)
      );
      const filteredEventsPast = allPastEvents.filter((event) =>
        selectedItems.includes(event.club.id)
      );
      setEvents(
        activeTab === "liveEvents" ? filteredEventsLive : filteredEventsPast
      );
    } else {
      setEvents(activeTab === "liveEvents" ? allLiveEvents : allPastEvents);
    }
  }, [selectedItems, activeTab, allLiveEvents, allPastEvents]);

  const handlePromoterClick = (promoterId, promoterName) => {
    promoterId
      ? setSelectedPromoter({ id: promoterId, name: promoterName })
      : setSelectedPromoter(null);
    if (selectedEventId) {
      fetchStatsForEvent(selectedEventId, promoterId);
    }
  };

  const handleEventClick = (id) => {
    if (id) {
      setSelectedEventId(id);
      setShowEventStats(true);
      fetchStatsForEvent(id);
    }
  };

  const handleBackClick = () => {
    setShowEventStats(false);
    setActiveSubTab("eventStats");
    // If we're in cards mode, going back means clearing the selectedEventId
    if (viewMode === "cards") {
      setSelectedEventId(null);
    }
  };

  const Tabs = () => {
    const handleTabClick = (tab) => {
      setActiveTab(tab);
      setActiveSubTab("eventStats");
      setShowEventStats(false);
      if (viewMode === "cards") {
        setSelectedEventId(null);
      }
    };
    return (
      <div className={AdminEventStatsS.tabsEvents}>
        <button
          className={activeTab === "liveEvents" ? AdminEventStatsS.active : ""}
          onClick={() => handleTabClick("liveEvents")}
        >
          Live Events
        </button>
        <button
          className={activeTab === "pastEvents" ? AdminEventStatsS.active : ""}
          onClick={() => handleTabClick("pastEvents")}
        >
          Past Events
        </button>
        <button
          onClick={() => {
            if (selectedEventId) {
              fetchStatsForEvent(selectedEventId);
            }
          }}
          style={{
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "10px",
            backgroundColor: "#F0F0F0",
            color: "#353943"
          }}
        >
          <FontAwesomeIcon icon={faSyncAlt} />
        </button>
      </div>
    );
  };

  const ViewToggle = ({ viewMode, setViewMode }) => (
    <div className={AdminEventStatsS.viewToggle}>
      <button
        className={
          viewMode === "cards"
            ? `${AdminEventStatsS.active} ${AdminEventStatsS.subtabsButton}`
            : AdminEventStatsS.subtabsButton
        }
        onClick={() => {
          setViewMode("cards");
          // If switching to cards from bar, event selection is handled by useEffect
        }}
      >
        Card View
      </button>
      <button
        className={
          viewMode === "bar"
            ? `${AdminEventStatsS.active} ${AdminEventStatsS.subtabsButton}`
            : AdminEventStatsS.subtabsButton
        }
        onClick={() => {
          setViewMode("bar");
          // If switching to bar and no event selected, handled by useEffect
        }}
      >
        Bar View
      </button>
    </div>
  );

  const ImageScroller = ({ data, selectedItems, setSelectedItems }) => {
    const toggleSelect = (id) => {
      setSelectedItems((prevSelectedItems) => {
        const updatedSelectedItems = prevSelectedItems.includes(id)
          ? prevSelectedItems.filter((item) => item !== id)
          : [...prevSelectedItems, id];
        return updatedSelectedItems;
      });
    };

    return (
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "10px 0",
          whiteSpace: "nowrap",
          scrollBehavior: "smooth",
          maxWidth: "450px",
          boxSizing: "border-box",
          marginBottom: "20px"
        }}
      >
        {data.map(({ _id, image, clubname }) => (
          <div
            key={_id}
            style={{
              display: "inline-block",
              textAlign: "center",
              marginLeft: "10px",
              marginRight: "10px",
              cursor: "pointer",
              transition: "transform 0.2s ease-in-out",
              transform: selectedItems.includes(_id) ? "scale(1.1)" : "none",
              border: selectedItems.includes(_id)
                ? "2px solid #007bff"
                : "none",
              borderRadius: selectedItems.includes(_id) ? "10px" : "none",
              width: "80%"
            }}
            onClick={() => toggleSelect(_id)}
          >
            <img
              src={image}
              alt={clubname}
              style={{
                width: "90px",
                height: "90px",
                objectFit: "cover",
                borderRadius: "5px"
              }}
            />
            <p style={{ marginTop: "5px", fontSize: "14px", color: "#333" }}>
              {clubname}
            </p>
          </div>
        ))}
      </div>
    );
  };

  if (isLoading)
    return (
      <div
        className={AdminEventStatsS.dashboardEventStats}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <ClipLoader
          color={"#00338d"}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );

  return (
    <div className={AdminEventStatsS.dashboardEventStats}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background:
            "linear-gradient(to right, rgba(91, 91, 91, 1), rgba(28, 57, 150, 1))",
          padding: "20px",
          borderRadius: "10px",
          marginTop: "none"
        }}
        className={AdminEventStatsS.headerEvents}
      >
        <div style={{ color: "white", fontWeight: "600", fontSize: "18px" }}>
          Launch a new Event!
        </div>
        <button style={{ borderRadius: "30%" }}>
          <img
            src={Frame}
            alt="Launch"
            style={{ width: "50px", height: "50px" }}
          />
        </button>
      </div>

      {/* Tabs and ViewToggle */}
      <div className={AdminEventStatsS.selectiontabEvents}>
        <Tabs />
        <ViewToggle viewMode={viewMode} setViewMode={setViewMode} />
      </div>
      <div className={AdminEventStatsS.selectioneventsEvents}>
        {/* Clubs selection */}
        {clubsData && clubsData.length > 0 && (
          <div
            style={{
              padding: "10px 0",
              boxSizing: "border-box"
            }}
          >
            <ImageScroller
              data={clubsData}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
            />
          </div>
        )}

        {/* If no events */}
        {events.length === 0 ? (
          <p>No events found.</p>
        ) : viewMode === "cards" ? (
          showEventStats ? (
            <EventStatistics
              eventId={selectedEventId}
              events={events}
              setSelectedEvent={setSelectedEventId}
              activeSubTab={activeSubTab}
              setActiveSubTab={setActiveSubTab}
              isLiveEvent={activeTab === "liveEvents"}
              stats={stats}
              promoters={promoters}
              handlePromoterClick={handlePromoterClick}
              selectedPromoter={selectedPromoter}
              tickets={tickets}
              setEvents={setEvents}
              handleBackClick={handleBackClick}
              adminId={clubId}
              clubId={clubId}
              role={role}
              adminKey={adminKey}
              BACKEND_URL={BACKEND_URL}
              viewMode={viewMode}
              fetchStatsForEvent={fetchStatsForEvent}
            />
          ) : (
            <EventCards
              events={events}
              handleEventClick={handleEventClick}
              isAscending={activeTab === "liveEvents"}
            />
          )
        ) : (
          // Bar view
          <EventStatistics
            eventId={selectedEventId}
            events={events}
            setSelectedEvent={setSelectedEventId}
            activeSubTab={activeSubTab}
            setActiveSubTab={setActiveSubTab}
            isLiveEvent={activeTab === "liveEvents"}
            stats={stats}
            promoters={promoters}
            handlePromoterClick={handlePromoterClick}
            selectedPromoter={selectedPromoter}
            tickets={tickets}
            setEvents={setEvents}
            handleBackClick={handleBackClick}
            adminId={clubId}
            clubId={clubId}
            role={role}
            adminKey={adminKey}
            BACKEND_URL={BACKEND_URL}
            viewMode={viewMode}
            fetchStatsForEvent={fetchStatsForEvent}
          />
        )}
      </div>
    </div>
  );
};

export default ClubOwnerEventStats;
